const ACTIONS = {
  GET_PLAYLIST: "GetPlaylist",
};

export { ACTIONS };
